import { formatInTimeZone } from 'date-fns-tz';

export const getCheckOutAvailability = (
  reservation: { endDate: string; status: string },
  timezone: string,
  now: Date = new Date(),
) => {
  // get departure date in the property's timezone
  const departureDateInPropertyTimezone = reservation.endDate;

  // today's date in property's timezone
  const todayInPropertyTimezone = formatInTimeZone(now, timezone, 'yyyy-MM-dd');

  return {
    canCheckOut: ['checked_in'].includes(reservation.status),
    isDepartureDay: todayInPropertyTimezone === departureDateInPropertyTimezone,
  };
};
